import _ from 'lodash';

import { createApiReducer } from 'src/api';

import {
  ADD_OBLIGATION_START,
  ADD_OBLIGATION_SUCCESS,
  ADD_OBLIGATION_FAILURE,
  UPDATE_OBLIGATION_START,
  UPDATE_OBLIGATION_SUCCESS,
  UPDATE_OBLIGATION_FAILURE,
  DELETE_OBLIGATION_START,
  DELETE_OBLIGATION_SUCCESS,
  DELETE_OBLIGATION_FAILURE,
} from './actions';

export const transformObligation = response => ({
  id: response.id,
  obligationCreditor: response.obligation_creditor,
  obligationDateOpened: response.obligation_date_opened,
  obligationOriginalAmount: response.obligation_original_amount,
  obligationMonthlyPayment: response.obligation_monthly_payment,
  obligationSecuredBy: response.obligation_secured_by,
  obligationPresentBalance: response.obligation_present_balance,
  obligationIsArchived: response.obligation_is_archived,
  obligationAddedDate: response.obligation_added_date,
});

const updateItem = (list, key, value, newItem) => {
  return list.map(item => {
    if (item[key] === value) {
      return newItem;
    }
    return item;
  });
};

const accountAddObligationReducer = createApiReducer(
  [ADD_OBLIGATION_START, ADD_OBLIGATION_SUCCESS, ADD_OBLIGATION_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      obligations: [...state.data.obligations, transformObligation(payload)],
    };
  },
  error => transformObligation(_.get(error, 'payload.response', {}))
);

const updateObligations = (payload, state) => {
  const newObligation = transformObligation(payload);

  return {
    ...state.data,
    obligations: updateItem(
      state.data.obligations,
      'id',
      newObligation.id,
      newObligation
    ),
  };
};

const accountUpdateObligationReducer = createApiReducer(
  [
    UPDATE_OBLIGATION_START,
    UPDATE_OBLIGATION_SUCCESS,
    UPDATE_OBLIGATION_FAILURE,
  ],
  updateObligations,
  error => transformObligation(_.get(error, 'payload.response', {}))
);

const accountDeleteObligationReducer = createApiReducer(
  [
    DELETE_OBLIGATION_START,
    DELETE_OBLIGATION_SUCCESS,
    DELETE_OBLIGATION_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      obligations: state.data.obligations.filter(l => l.id !== payload.id),
    };
  },
  error => _.get(error, 'payload.response') || {}
);

export const reducers = [
  accountAddObligationReducer,
  accountUpdateObligationReducer,
  accountDeleteObligationReducer,
];
